import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@services/global-loader.service';


@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent implements OnInit {

  isLoading = false;

  constructor(private loaderService: LoaderService,) { }

  ngOnInit(): void {
    this.loaderService.loading$.subscribe((loading) => {
      this.isLoading = loading;
    });
  }

}
